<template>
  <div class="cellInfo">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="cellInfo" class="iconstyle"></svg-icon>小区信息
      </span>
      <span class="other more" @click="jumpMore" v-if="Isywh">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="title" @click="enterEaArea(cellData.EaAreaCode)">{{cellData.EaAreaName}}</div>
      <div class="Info">
        维修资金余额：
        <span class="money">0</span>
        <span>元</span>
      </div>
      <div class="Info">
        业委会主任:
        <span>{{cellData.MasterName}} {{cellData.MasterTel}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {HomePageControllerSvr} from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import { mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      Isywh:true,
      cellData:{
        EaAreaName: '',
        MasterName: '',
        MasterTel: '',
      }
    };
  },
  computed: {
    ...mapState(['token','userInfo'])
  },
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    if(this.userInfo.UserParam.UserType==='业委会用户'){
      this.Isywh =false;
    }
    this.homePageControllerSvr.GetAreaInfo(this.token,0,1).then(res=>{
      if (res._Items.length > 0) {
        this.cellData=res._Items[0];
      }
    });
  },
  methods:{
    enterEaArea(code) {
      if(code){
      this.$router.push({
        path:'/propertyAreaInfo',
        query:{OrgCode:code,t: Date.now()}});
      }
},
    jumpMore(){
      this.$router.push('/queryPropertyArea');
    }
  }
};
</script>
<style lang="scss" scoped>
.cellInfo {
  background: #fff;
  .iconstyle {
    font-size: 18px;
    margin: 0 6px;
    color: #67aafe;
  }
  .more{
    transition: all .3s;
    &:hover{
      color: #0f77f2;
    }
  }
  .container {
    height: 124px;
    overflow: hidden;
    padding: 12px;
    .title {
      color: #333333;
      line-height: 35px;
      font-size: 14px;
      font-weight: bold;
      transition: all .3s;
      cursor: pointer;
      &:hover{
        color: #0f77f2;
      }
    }
    .Info{
      font-size: 14px;
      line-height: 30px;
      color: #666;
      .money{
        color: #0f77f2;
        font-weight: bold
      }
    }
  }
}
</style>